import {SEARCH_AGENCY} from './actionTypes';

export default function searchForAgency(_id) {
  return {type: SEARCH_AGENCY, _id}
}
